import { DialogActions, makeStyles, Typography } from '@material-ui/core';
import Button from '../common/button';
import ModalV2 from '../common/modal-v2';
import { PublicMentor } from '../../api/mentors';
import { useResourceBundles } from '../../contexts/resource-bundles-context';

const useStyles = makeStyles(() => ({
  message: {
    marginBottom: 24,
  },
  listLabel: {
    fontWeight: 600,
    marginTop: 16,
    marginBottom: 8,
  },
  list: {
    paddingLeft: 20,
    margin: 0,
    marginBottom: 16,
  },
  listItem: {
    marginBottom: 4,
  },
  listItemText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  actions: {
    padding: '32px 0 0',
  },
}));

interface ConfirmFounderRecommendationsApproveProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedMentors: PublicMentor[];
  unselectedMentors: PublicMentor[];
}

const ConfirmFounderRecommendationsApprove = ({
  open,
  onClose,
  onConfirm,
  selectedMentors,
  unselectedMentors,
}: ConfirmFounderRecommendationsApproveProps) => {
  const classes = useStyles();
  const { rb } = useResourceBundles();

  return (
    <ModalV2
      open={open}
      onClose={onClose}
      width="600px"
      titleProps={{
        title: 'Confirm Selection',
      }}
    >
      <div className={classes.message}>
        <Typography variant="body1">
          Please review your selection before approving.
        </Typography>

        {selectedMentors.length > 0 && (
          <>
            <Typography variant="body1" className={classes.listLabel}>
              You have selected the following {rb('mentors')}:
            </Typography>
            <ul className={classes.list}>
              {selectedMentors.map((m) => (
                <li key={m.id} className={classes.listItem}>
                  <Typography variant="body2" className={classes.listItemText}>
                    {m.firstName} {m.lastName}
                  </Typography>
                </li>
              ))}
            </ul>
          </>
        )}

        {unselectedMentors.length > 0 && (
          <>
            <Typography variant="body1" className={classes.listLabel}>
              You have NOT selected:
            </Typography>
            <ul className={classes.list}>
              {unselectedMentors.map((m) => (
                <li key={m.id} className={classes.listItem}>
                  <Typography variant="body2" color="error" className={classes.listItemText}>
                    {m.firstName} {m.lastName}
                  </Typography>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>

      <DialogActions className={classes.actions}>
        <Button variant='outlined' onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={selectedMentors.length === 0}
        >
          Approve
        </Button>
      </DialogActions>
    </ModalV2>
  );
};

export default ConfirmFounderRecommendationsApprove;
